var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 48.04,
    height: 46.747,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 950.26 924.67",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 529.32,
    y1: 1072.34,
    x2: 370.29,
    y2: 239
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 454.19,
    y1: 975.76,
    x2: 505.11,
    y2: -271.55
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 438.26,
    y1: 704.1,
    x2: 466.58,
    y2: 37.01
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 618.55,
    y1: 1054.8,
    x2: 459.58,
    y2: 221.76
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 617.67,
    y1: 1055.24,
    x2: 458.66,
    y2: 222.01
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 677.48,
    y1: 2034.15,
    x2: 412.16,
    y2: -399.98
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 502.74,
    y1: 1070.18,
    x2: 343.71,
    y2: 259.21
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#bc6f3b"
    }
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 650.53,
    y1: 1043.04,
    x2: 491.55,
    y2: 214.6
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 458.39,
    y1: 341.01,
    x2: 534.75,
    y2: 856.46
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 600.4,
    y1: 3672.35,
    x2: 545.34,
    y2: 2313.43
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 558.05,
    y1: 1042.89,
    x2: 399.01,
    y2: 252.74
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 837.85,
    y1: 1013.62,
    x2: 682.22,
    y2: 180.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 423.69,
    y1: 1044.21,
    x2: 416.62,
    y2: 795.47
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#804125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#9a522d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#b46336"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m365.87 305.35 35.92.06-.03 36.08-36.1-.21.21-35.93zM497.3 510.92c-18.89 4.68-21.2 29.49-5.49 38.52 7.58 4.36 20.11 2.78 29.51 2.79 7.32.01 26.52.84 32.33-.7 17.85-4.69 20.92-29.49 5.14-38.48-7.44-4.25-20.01-2.81-29.45-2.81-7.6 0-25.88-.85-32.04.67zm90-97.02c-9.32 1.97-16.2 9.38-16.71 20.07-.46 9.94-.94 66.9 1.55 73 8.32 20.47 39.29 15.98 40.37-7.4.45-9.82.94-67.13-1.48-72.98-3.19-7.69-12.02-15.15-23.73-12.69zm-84.94 28.65c-.37 15.57-2.38 30.63 6.12 39.23 9.51 9.63 25.02 7.45 31.57-2.1 6.59-9.62 4.23-27.47 4.23-40.59 0-16.84 2.02-27.8-10.06-35.49-7.73-4.92-31.06-3.07-42.05-3.07-16.99 0-28.53-2.76-37.92 7.93-8.73 9.94-3.85 25.52 5.53 30.97 9.36 5.44 30.07 2.49 42.56 3.11zM289.4 229.05c9.09-.75 53.93-.16 66.6-.12 28.43.07 29.82-25.44 19.24-35.57-8.23-7.89-13.99-6.41-27.26-6.41h-66.99c-12.1 0-20.4-.95-27.56 6.13-7.08 7-6.19 15.6-6.19 27.55v67c0 12.6-1.38 19.8 6.42 27.33 11.63 11.22 35.62 8.16 35.55-19.32-.03-10.59-.58-60.29.19-66.58zm357.48 357.48c-5.96.76-56.26.22-66.59.19-27.04-.09-30.81 23.27-19.3 35.53 7.38 7.86 14.89 6.43 27.32 6.43h67c11.45 0 21.1.64 27.59-6.15 6.92-7.24 6.09-15.52 6.09-27.59v-67c0-12.41 1.32-19.83-6.4-27.29-5.88-5.67-15.39-8.49-24.58-3.53-7.69 4.16-11.04 11.26-11.01 22.8.04 12.85.64 57.22-.11 66.6zm-357.52.05-.18-66.65c.29-28.19-25.31-29.88-35.51-19.29-7.92 8.23-6.43 14.11-6.43 27.3v67c0 29.22 4.37 33.74 33.75 33.74h66.99c13.3 0 19.06 1.48 27.31-6.43 10.32-9.91 9.36-35.62-19.3-35.54-11.83.04-58.65.6-66.63-.13zm357.48-357.5c.73 6.91.18 55.44.16 66.55-.02 11.54 3.41 18.74 10.95 22.85 8.87 4.84 19.1 2.32 24.66-3.56 7.86-8.31 6.38-14.06 6.38-27.3v-67c0-11.95.89-20.47-6.15-27.54-7.01-7.04-15.61-6.14-27.53-6.14h-67c-12.61 0-19.68-1.44-27.28 6.41-11.52 11.89-7.77 35.88 19.27 35.54l66.54.19zM365.67 474.32l36.06-.19.06 36.06-35.97.06-.15-35.93zm-23.8-41.87c-21.2 3.71-18.21 21.95-18.19 42.33.01 9.89-.64 54.5.4 60.34 3.75 21.12 27.21 17.11 42.84 17.12 9.63.01 54.58.66 60.24-.49 7.78-1.58 13.47-7.02 15.63-14.2 1.8-6.03.96-21.38.97-28.54.02-9.95.01-19.9 0-29.85-.01-17.7 4.47-39.7-14.22-45.87-6.13-2.02-48.62-1.11-58.25-1.11-7.42 0-23.04-.83-29.41.28zm192.59-127.06 35.94-.01.16 35.86-36.08.26-.02-36.1zm-26.05-41.24c-19.71 5.4-15.94 23.54-15.94 43.85 0 11.67-1.48 51.08.63 59.52 1.79 7.16 7.66 13.17 14.71 15.14 4.84 1.35 83.05 1.44 88.42.22 19.26-4.36 16.26-23.35 16.28-43.56.01-11.92 1.51-51.19-.61-60.06-4.81-20.13-27.5-15.86-44-15.87-11.15-.01-51.86-1.34-59.49.76zm-168.5-.13c-19.34 4.56-16.23 23.8-16.23 43.99 0 11.24-1.4 52.05.76 59.98 5.36 19.72 26.71 15.45 43.93 15.45 11.69 0 51.06 1.48 59.5-.64 20.06-5.03 15.88-26.59 15.88-43.47 0-9.32.67-54.17-.54-59.57-4.31-19.25-23.28-16.36-43.53-16.36-12.25 0-50.65-1.53-59.76.62z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.26 462.43c0 49.46-7.92 96.93-22.79 141.66-26.94 81.93-76.85 153.79-142.21 208.4-29.57 24.93-62.33 46.37-97.74 63.43-63.86 31.32-136.02 48.74-212.3 48.74-146.73 0-278.01-64.71-365.03-166.43-40.32-46.91-71.2-101.72-89.85-161.84C7.14 554.06-.01 508.96-.01 462.43c0-16.7.94-33.02 2.65-49.13 2.81-25.47 7.72-50.42 14.5-74.6 3.95-14.11 8.66-27.85 14.14-41.24 11.12-28.77 25.22-56.27 42.17-81.93 28.07-43.64 63.85-82.3 105.11-114.38 11.69-9.16 23.92-17.95 36.72-25.82C289.86 27.65 379.16.01 475.22.01c132.61 0 252.57 52.95 338.67 138.35 21.28 20.91 40.5 43.81 57.07 68.39 2.64 3.47 4.89 6.95 7.15 10.62 14.13 21.82 26.2 44.74 36.36 68.74 16.75 39.23 27.87 81.19 32.78 125 2.05 16.88 3.01 33.91 3.01 51.34z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.52 406.67c0 4.8 0 9.4-.41 14-.59 22.18-2.97 43.78-7.18 64.77-3.18 15.79-7.19 31-12 45.99-1 3.39-2.18 6.59-3.39 10-3.18 9.38-6.98 18.57-10.78 27.78-7.39 16.99-15.96 33.19-25.35 48.98-7.62 12.19-15.8 24.2-24.58 35.59-13.59 17.6-28.37 33.98-44.54 48.96-4.19 4.22-8.61 8-13 11.8-19.36 17.01-40.54 31.99-63.11 44.79-6.59 4.01-13.39 7.62-20.39 10.99-32.54 16.4-67.7 28.6-104.46 35.4a394.328 394.328 0 0 1-77.09 7.61c-65.93 0-128.04-15.81-182.99-43.59-28.74-14.42-55.33-32.19-79.47-52.77-17.99-15.23-34.56-31.99-49.74-49.99-15.99-19.19-30.17-39.8-42.16-61.59-9.76-16.99-18.17-34.58-25.16-52.97-3.6-9.2-6.8-18.38-9.59-27.8-2.18-7.57-4.39-15.38-6.2-23.17-3.58-14.8-6.39-29.98-7.98-45.6-2.21-15.98-3.21-32.58-3.21-49.18 0-14.59.81-28.98 2.43-43.17 2.37-22.4 6.56-44.41 12.36-65.58 1.59-6 3.4-12 5.39-17.79 2-6.39 4.19-12.59 6.6-18.59 3.01-8 6.39-15.8 10-23.59 5.19-11.99 11.36-23.57 17.97-34.98 2.6-4.61 5.39-9 8.2-13.39 9.38-15 19.56-29.2 30.75-42.59 17.58-21.4 37.55-40.78 59.12-57.96 8.79-7.2 17.97-14 27.79-20.42 1.17-.78 2.37-1.58 3.6-2.37 15.37-10.2 31.33-19.2 48.13-27.03C346.81 14.05 405.93.07 468.26.07c59.32 0 115.65 12.76 166.6 35.77 16.76 7.39 32.95 16.18 48.52 25.99 27.17 16.99 52.14 37.19 74.51 59.97l.4.4c9.79 9.79 18.97 20.19 27.76 31.21 7.2 8.98 14.2 18.58 20.59 28.37 2.18 3.2 4.19 6.2 6.19 9.4a401.682 401.682 0 0 1 30.97 60.39c3.38 8.17 6.56 16.59 9.36 25.16 5.21 15.39 9.61 31.21 12.8 47.19 2.59 12.39 4.58 24.99 6 37.6.4 3.6.81 6.98 1 10.58 1.18 11.41 1.59 23 1.59 34.58z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.13 69.02c-106.88.4-213.94.19-320.79-.42 1.17-.78 2.37-1.58 3.6-2.37 15.37-10.2 31.33-19.2 48.13-27.03 76.89-1.17 153.99-1.96 230.9-2.59 36.55-.37 73.32-.58 109.88-.78 16.76 7.39 32.95 16.18 48.52 25.99-42.75 2.4-85.49 7-120.23 7.2z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.19 759.32c-6.59 4.01-13.39 7.62-20.39 10.99-32.54 16.4-67.7 28.6-104.46 35.4-86.89-9.4-173.97-29.99-260.09-35.98-28.74-14.42-55.33-32.19-79.47-52.77 60.5-3.42 122.02 2.79 184.96 12.57 76.92 12.02 154.01 29.79 231.91 29.79 6.98 0 26.17.42 47.54 0z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.21 616.37c28.96 6.61 97.68 15 147.62 37.4-13.59 17.6-28.37 33.98-44.54 48.96-18.97-19.59-63.94-24.78-80.71-28.98-153.39-38.38-311.42-52.98-468.41-67.58-16.58-1.59-48.35-.17-83.29-.78-9.76-16.99-18.17-34.58-25.16-52.97 31.95 2.59 72.71.39 89.89 1.98 155.58 14 311.98 27.39 464.59 61.98z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.17 167.18c-184.76 16.4-371.13 12.79-555.69 35.78 2.6-4.61 5.39-9 8.2-13.39 9.38-15 19.56-29.2 30.75-42.59 38.78-1.41 74.91-1 100.27-2.42 151.2-8.37 303.63-2.37 454.24-16.57 15.97-1.58 32.17-3.2 48.33-5.79 9.79 9.79 18.97 20.19 27.76 31.21-40.96 8.4-83.28 10.99-113.86 13.79z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.02 573.81c18.97-.22 32.95-2.01 42.74-4.61-7.39 16.99-15.96 33.19-25.35 48.98-6.39.39-12.4.61-17.39.61-78.9.78-159.41-23.42-236.89-33.58-56.14-7.22-111.07-15-165.6-30.2-81.91-22.79-162.79-57.97-249.28-58.38-9.2 0-44.95-.4-73.32 4.81-3.58-14.8-6.39-29.98-7.98-45.6 18.56-3.99 35.93-6.19 48.52-7.19 124.66-9.6 238.91 52.16 357.96 77.37 63.72 13.39 129.84 18.38 193.96 29.2 43.94 7.2 87.89 19.17 132.63 18.59z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.92 280.73c-3.01-.19-6-.41-9-.61 2-6.39 4.19-12.59 6.6-18.59 3.01-8 6.39-15.8 10-23.59 41.32 6 89.67 2.81 128.82 5.41 91.09 6.2 182.18 11.8 273.25 16.78 117.46 6.61 234.91 11.99 352.55 16.6 5.21 15.39 9.61 31.21 12.8 47.19-147.82-5.78-295.61-12.8-443.44-21.4-110.65-6.39-221.11-13.79-331.57-21.79z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.35 425.45c-68.11 9.2-138.22 9.42-207.52 9.82 61.92 46.18 155.19 36.57 228.11 50.17-3.18 15.79-7.19 31-12 45.99-1 3.39-2.18 6.59-3.39 10-10.58-8.99-30.55-17.4-51.93-20.2-88.3-11.79-176.38-19.41-231.51-96.56-10.38-14.79 3.82-33.17 19.39-33.98 74.1-3.21 148.81-2.42 222.53-8.62 21.76-1.79 42.52-5.18 62.91-9.98 1.18 11.41 1.59 23 1.59 34.58 0 4.8 0 9.4-.41 14-9.18 2-18.39 3.61-27.77 4.78z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.68,
    y: 182.23,
    width: 528.44,
    height: 494.55,
    rx: 35.71,
    ry: 39.28,
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.57,
    y: 160.53,
    width: 528.44,
    height: 494.55,
    rx: 35.71,
    ry: 39.28,
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.5 482.63c-.77-6.92-1.16-11.72-1.16-14.41 0-16.53 3.85-31.13 11.54-43.82 7.69-12.69 18.44-26.52 32.28-41.51 9.61-10.38 16.63-18.74 21.05-25.08 4.42-6.34 6.63-12.78 6.63-19.31 0-9.61-2.98-16.82-8.94-21.62-5.95-4.81-13.73-7.21-23.35-7.21-8.84 0-16.72 1.92-23.63 5.76-6.92 3.84-14.8 10-23.64 18.45l-54.19-49.58c14.6-16.91 31.71-30.17 51.31-39.78s40.55-14.41 62.84-14.41c34.2 0 61.78 8.26 82.73 24.79 20.95 16.53 31.42 42.08 31.42 76.67 0 15.38-3.46 28.63-10.38 39.78-6.92 11.15-17.3 23.83-31.14 38.05-13.07 13.45-22.77 25.46-29.11 36.03s-8.93 22.97-7.78 37.19H355.5zm42.66 147.59c-16.52 0-30.26-5.76-41.22-17.29-10.95-11.53-16.42-25.76-16.42-42.67s5.47-31.13 16.42-42.66c10.96-11.54 24.7-17.3 41.22-17.3 16.53 0 30.27 5.76 41.22 17.3 10.95 11.53 16.43 25.75 16.43 42.66 0 16.91-5.48 31.14-16.43 42.67-10.95 11.53-24.69 17.29-41.22 17.29z",
    style: {
      fill: "url(#m)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.65 459.94c-.77-6.92-1.16-11.72-1.16-14.41 0-16.53 3.85-31.13 11.54-43.82 7.69-12.69 18.44-26.52 32.28-41.51 9.61-10.38 16.63-18.74 21.05-25.08 4.42-6.34 6.63-12.78 6.63-19.31 0-9.61-2.98-16.82-8.94-21.62-5.95-4.81-13.73-7.21-23.35-7.21-8.84 0-16.72 1.92-23.63 5.76-6.92 3.84-14.8 10-23.64 18.45l-54.19-49.58c14.6-16.91 31.71-30.17 51.31-39.78s40.55-14.41 62.84-14.41c34.2 0 61.78 8.26 82.73 24.79 20.95 16.53 31.42 42.08 31.42 76.67 0 15.38-3.46 28.63-10.38 39.78-6.92 11.15-17.3 23.83-31.14 38.05-13.07 13.45-22.77 25.46-29.11 36.03s-8.93 22.97-7.78 37.19h-86.48zm42.66 147.59c-16.52 0-30.26-5.76-41.22-17.29-10.95-11.53-16.42-25.76-16.42-42.67s5.47-31.13 16.42-42.66c10.96-11.54 24.7-17.3 41.22-17.3 16.53 0 30.27 5.76 41.22 17.3 10.95 11.53 16.43 25.75 16.43 42.66 0 16.91-5.48 31.14-16.43 42.67-10.95 11.53-24.69 17.29-41.22 17.29z",
    style: {
      fill: "#4a2615",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestIcon);
export default __webpack_public_path__ + "static/media/quest_icon.9442929d9423f96f774f121f9fc16e70.svg";
export { ForwardRef as ReactComponent };